import { render } from "./sectionf.vue?vue&type=template&id=681f6052"
import script from "./sectionf.vue?vue&type=script&lang=js"
export * from "./sectionf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__